// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__Z8qJp","topBottomGutter":"Layout_topBottomGutter__23ubS"};